/* eslint-disable react/prop-types */

import { NationalVendorPage } from "./NationalVendorPage";

export const NationalResultsPage = NationalVendorPage;
